import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';
import { SkeletonLoader } from '@web/components/skeleton-loader';
import { QUICK_REFERENCE_CARD_WIDTH } from './quick-reference-card';

const useStyles = createUseStyles({
    card: {
        flex: '0 0 auto',
        width: QUICK_REFERENCE_CARD_WIDTH,
        border: `1px solid ${colors.grayThree}`,
        borderRadius: 8,
        overflow: 'hidden',
        backgroundColor: colors.white,
    },
    media: {
        height: 96,
        borderBottom: `1px solid ${colors.grayThree}`,
        backgroundColor: colors.grayTwo,
    },
    body: {
        padding: '12px 14px 12px',
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 14px 12px',
    },
});

export const QuickReferenceCardSkeleton: FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.card} data-testid="quick-reference-card-skeleton">
            <div className={classes.media} />
            <div className={classes.body}>
                <SkeletonLoader type="text" width="90%" height={14} />
                <SkeletonLoader type="text" width="60%" height={14} />
            </div>
            <div className={classes.footer}>
                <SkeletonLoader type="text" width={96} height={12} />
                <SkeletonLoader type="icon" width={32} height={32} />
            </div>
        </div>
    );
};
